import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div  style={{ fontSize:'10rem' }}>PageNotFound-<Link to="/" style={{ fontSize:'10rem' }}>Go home.</Link></div>
  )
}

export default PageNotFound